import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import ConfirmDialog from 'common/components/modal/confirmation_dialog';
import { makeAccountDefault } from 'common/ducks/payout';

const mapStateToProps = (state, { account }) => {
  return {
    dialogVisible: !!account,
    dialogHeader: account? `Make ${account.system} account the default?` : '',
    dialogMessage: account? `Are you sure you want to make ${account.system == 'paypal'? 'PayPal' : 'Payoneer'} the default way we pay you?` : ''
  };
}

const mapDispatchToProps = (dispatch, { account, onSuccess, onToggle }) => {
  const actions = bindActionCreators({
    submitAction: partial(makeAccountDefault, account, onSuccess)
  }, dispatch);

  return {
    ...actions,
    toggleDialog: onToggle
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog);



// WEBPACK FOOTER //
// ./account/containers/payout/make_acc_default_modal.js